module.exports = __webpack_public_path__ + "img/bg-induce-02.d51b36be.png";